export class ApplyEligibilityCheckRequest {
    StudentID: string;
    AcademicYearID: number;
    ApplicationTypeID: number;
}